import { REPLACE, CLEAR, SET_PAGESIZE, SET_PAGENUMBER, SET_FILTERS } from './actions';

const initialState = {
    referralItems: [],
    totalResults: 0,
    totalPage: 1,
    pageSize: 10,
    pageNumber: 1,
    filters: {
    },
}

export default function main (state = initialState, action) {
    switch (action.type) {
        case REPLACE:
            return {
                ...state,
                referralItems: action.referralItems,
                totalResults: action.totalResults,
                totalPage: action.totalPage,
            }
        case SET_PAGESIZE:
            return {
                ...state,
                pageSize: action.pageSize
            }
        case SET_PAGENUMBER:
            return {
                ...state,
                pageNumber: action.pageNumber
            }
        case SET_FILTERS:
            return {
                ...state,
                pageNumber: 1,
                filters: {
                },
            }
        case CLEAR:
            return initialState
        default:
            return state;
    }
}